import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromLayout from '../reducers/layout.reducers';

export const selectLayoutState = createFeatureSelector<fromLayout.State>(fromLayout.featureKey);

/**
 * @ deprecated Não está mais sendo usado menu no state global.
 */
// export const selectLayoutMenu = createSelector(selectLayoutState, state => state.menu);

/**
 * @ deprecated Não está mais sendo usado breadcrumb no state global.
 */
// export const selectLayoutBreadcrumb = createSelector(selectLayoutState, state => state.breadcrumb);

export const selectPageTitle = createSelector(selectLayoutState, state => state.title);

export const selectFullscreen = createSelector(selectLayoutState, state => state.fullscreen);
